import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { DataService_BellScheduleSetup } from "../../data.service";
import * as moment from "moment";

@Component({
	selector: "app-add-period",
	templateUrl: "./add-period.component.html",
	styleUrls: ["./add-period.component.css"],
})
export class AddPeriodComponent implements OnInit {
	constructor(private ref: DynamicDialogRef, private BellScheduleSetupService: DataService_BellScheduleSetup, private dialogConfig: DynamicDialogConfig) {}

	ngOnInit(): void {
		//Get data from parent
		this.SchoolID = this.dialogConfig.data.SchoolID;

		//Get Data from DB
		this.loadPeriodList();
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	SchoolID: any;

	SelectedPeriods: any = [];
	lstPeriod: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "PeriodNo", header: "Period Number" },
		{ field: "PeriodDesc", header: "Description" },
	];

	loading: any = false;

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	private loadPeriodList() {
		var result = this.BellScheduleSetupService.LoadPeriods(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstPeriod = response;

				for (var i = 0; i < this.lstPeriod.length; i++) {
					var next = this.lstPeriod[i];

					next.StartTimeDesc = moment(new Date(next.StartTime)).format("h:mm:ss A");
					next.EndTimeDesc = moment(new Date(next.EndTime)).format("h:mm:ss A");
					next.TardyTimeDesc = moment(new Date(next.TardyTime)).format("h:mm:ss A");

					next.StartTimeDate = new Date(next.StartTime);
					next.EndTimeDate = new Date(next.EndTime);
					next.TardyTimeDate = new Date(next.TardyTime);
				}

				this.UpdateSelected();
			},
			(error) => {}
		);
	}

	UpdateSelected() {
		this.SelectedPeriods = this.dialogConfig.data.SelectedPeriods;

		for (var i = 0; i < this.lstPeriod.length; i++) {
			var nextPeriod = this.lstPeriod[i];

			for (var z = 0; z < this.SelectedPeriods.length; z++) {
				var nextSelect = this.SelectedPeriods[z];

				if (nextPeriod.PeriodID == nextSelect.PeriodID) {
					nextPeriod.StartTimeDate = nextSelect.StartTimeDate;
					nextPeriod.EndTimeDate = nextSelect.EndTimeDate;
					nextPeriod.TardyTimeDate = nextSelect.TardyTimeDate;
				}
			}
		}
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onSelectAll() {}
	onUnselectAll() {}
	onUpdate() {
		//
		// Need to update periods already in the selected list
		// ngModel bound to one list but not the other?
		//

		for (var i = 0; i < this.SelectedPeriods.length; i++) {
			var nextSelect = this.SelectedPeriods[i];

			for (var z = 0; z < this.lstPeriod.length; z++) {
				var nextPeriod = this.lstPeriod[z];

				if (nextSelect.PeriodID == nextPeriod.PeriodID) {
					nextSelect.StartTimeDate = nextPeriod.StartTimeDate;
					nextSelect.EndTimeDate = nextPeriod.EndTimeDate;
					nextSelect.TardyTimeDate = nextPeriod.TardyTimeDate;

					break;
				}
			}
		}

		this.ref.close(this.SelectedPeriods);
	}
	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	///////////////////////////////////////////////////////
}
